import SalesManagerCollector from './SalesManagerCollector';

export default SalesManagerCollector;
